"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaypalPaymentState = void 0;
exports.PaypalPaymentState = {
    Created: "created",
    Approved: "approved",
    Failed: "failed",
};
//# sourceMappingURL=PaypalPaymentState.js.map